export const DRIVE_URL = "https://drive.google.com/uc?export=view&id=";
// const WORKSHOP_IMAGE = DRIVE_URL+'1fBUJCOhfn76ZVQU1Zw9B8dTmue2wfE4N';
export const WORKSHOP_IMAGE = DRIVE_URL + "1OC7x6O-zMYt_1Qmeh_pdIduMGrSPR3ee";
export const EXPO_IMAGE = DRIVE_URL + "1hmfiabJR_pe6fL4t78kZcjBAkcEn0LLi";
// https://drive.google.com/file/d/133nkCL8mxnKrmmbLH_CyNu4EVEXIsXfn/view?usp=sharing
export const RECRUITMENT_DONE_IMG_2019 =
  DRIVE_URL + "133nkCL8mxnKrmmbLH_CyNu4EVEXIsXfn";
export const RECRUITMENT_DONE_IMG =
  DRIVE_URL + "17x-aImkB8cVXjfyKmr9Q3q7DSeOkbJqj";


export const displayRecruitment = true;

export const displaySignUp = false;

export const branchesList = [
  { value: "CSE/IT/ICT", text: "CSE/IT/ICT or One of School of Computing" },
  {
    value: "ECE/EEE/EIE",
    text: "ECE/EEE/EIE or One of School of Electrical & Electronics Engg."
  },
  {
    value: "MECH/MCT/AERO",
    text: "MECH/MCT/AERO or One of School of Mechanical Engg."
  },
  {
    value: "BIO-CHEM/CIVIL",
    text:
      "BIO-CHEM/CIVIL or One of School of Civil Engg. or School of Chemical & BioTech."
  },
  {
    value: "MTECH-MECH",
    text: "MTECH-MECH or One of MTech Integrated in Mechanical Engg."
  },
  {
    value: "MTECH-ELECTRICAL",
    text:
      "MTECH-ELECTRICAL or One of MTech Integrated in Electrical & Electronics Engg."
  }
];

export const hostelTypeList = [
  { value: "HOSTELER", text: "In one of SASTRA Hostels  🤦😥" },
  { value: "DAY_SCHOLAR", text: "A day scholar, so I travel 1-2hrs a day  🤦😥" }
];

export const batchesList = [
  2013,
  2014,
  2015,
  2016,
  2017,
  2018,
  2019,
  2020,
  2021,
  2022,
  2023
];

export const randomProjectsCountLanding = 3;

export const ABOUT_US_PARA_1 =
  // eslint-disable-next-line no-multi-str
  "From the beginning of time immemorial, mankind was obsessed \
  with giving life to the inanimate. From Da Vinci's crude \
  automaton to present day's sophisticated Sophia, we approach \
  ever closer to realising humanity's deepest desire to create \
  the perfect machine. This unending passion has brought \
  students across branches together into a single entity,RCS. \
  Here at RCS we have just a simple goal: explore,experiment \
  and evolve. From most humble beginnings: assembling simple \
  switch controlled remote cars to greater heights: \
  constructing 9 channel RF controlled high maneuverability \
  quad copters , Robotics Club @ SASTRA has come a long way \
  and will continue on achieving more.";

export const ABOUT_US_PARA_2 =
  // eslint-disable-next-line no-multi-str
  '"The building is only as tall as the foundation is strong \
enough to build on!" reflects our core beliefs, which is why \
we take it upon ourselves to build those foundations for our \
younger generations through our introductory workshops. We \
proudly showcase our strength and heights we reached by \
participating in a multitude of competitions and publicly \
displaying our ingenuity and hard work in our expo!';

export const RECRUITMENT_PARA =
  // eslint-disable-next-line no-multi-str
  "Congratulations! We welcome you to the world of robots. Team RCS works together in every facet. Be ready to make your hands dirty with a pile of electronics and unhesitant to play the keyboard of programming. Let's gear our skills and talents to one of the most important careers of the now and future. Welcome to RCS!";

export const CraftedByV = {
  "batch": 2019,
  "branch": "CSE/IT/ICT",
  "created_at": "2019-04-25T10:46:48.768137+00:00",
  "deleted": false,
  "details": {
      "areas_of_expertise": "Python,JS,Java,Machine Learning",
      "created_at": "2019-04-25T10:46:48.867252+00:00",
      "current_designation": "SDE at Ninjacart, Bangalore",
      "deleted": false,
      "drive_image": null,
      "email": "vivek.pothina@gmail.com",
      "github": "ViveK-PothinA",
      "id": 0,
      "linkedin": "vivekpothina",
      "medium": "vivekpothina",
      "member_id": 0,
      "milestones": "",
      "mobile_num": "0000000000",
      "modified_at": "2019-06-07T11:16:46.462742+00:00",
      "vision": "A team that is always striving to make itself better!"
  },
  "gender": "MALE",
  "hostel_type": "HOSTELER",
  "id": 0,
  "modified_at": "2019-06-07T11:16:46.462742+00:00",
  "name": "Vivek Pothina",
  "reg_no": 119003200
}
